var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 16C123.451 16 16 123.453 16 256S123.451 496 256 496S496 388.547 496 256S388.549 16 256 16ZM448 256C448 292.695 437.469 326.895 419.539 356.082L280 244.449V65.664C374.559 77.535 448 158.277 448 256ZM232 446.336C189.652 441.02 151.576 421.937 122.412 393.621L232 305.949V446.336ZM280 305.949L389.588 393.621C360.424 421.938 322.348 441.02 280 446.336V305.949ZM232 65.664V244.449L92.461 356.082C74.531 326.895 64 292.695 64 256C64 158.277 137.441 77.535 232 65.664Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeace);
export default __webpack_public_path__ + "static/media/peace.fea12e23942efceb695e61ad14fcc3f2.svg";
export { ForwardRef as ReactComponent };